import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import type { ReactNode } from 'react';

interface ScreenHeaderProps {
  title: string;
  action?: ReactNode;
  backTo?: string;
  // For a screen whose back arrow needs to do more than just navigate
  // away (e.g. TemplatePickerScreen committing the current selection
  // before leaving) - takes priority over backTo when both are given.
  onBack?: () => void;
}

export function ScreenHeader({ title, action, backTo, onBack }: ScreenHeaderProps) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center gap-2 mb-1">
      <button
        onClick={() => (onBack ? onBack() : backTo ? navigate(backTo) : navigate(-1))}
        className="inline-flex items-center justify-center w-9 h-9 rounded-full hover:bg-black/5 dark:hover:bg-white/10 -ml-2 shrink-0"
        aria-label="Back"
      >
        <ChevronLeft size={22} />
      </button>
      <h1 className="text-xl font-bold tracking-tight m-0 flex-1 truncate">{title}</h1>
      {action}
    </div>
  );
}
